<template>
    <div class="GraphLegend">
        <ul class="Utility__list-unstyled">
            <li :class="classes" v-for="(label, index) in displayLabels">
                <span class="GraphLegend__colour" :style="backgroundColour(index)"></span>
                <span class="GraphLegend__label">{{ getLabel(label) }}:</span>
                <span class="GraphLegend__value">
                    {{ value(index, 'values') }}
                    <div v-if="hasComparison" class="GraphLegend__comparison-value">
                        <span class="GraphLegend__comparison-value-label">
                            Comp Year:
                        </span>
                        {{ value(index, 'comparisonValues') }}
                    </div>
                </span>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                displayLabels: [],
                colours: [],
                values: [],
                comparisonValues: [],
            }
        },

        props: {
            labels: {
                required: true,
                type: Array,
            },

            datasets: {
                required: true,
                type: Array,
            },

            displayValue: {
                type: String,
                default: 'value'
            },

            limit: {
                type: Number,
                default: null,
            }
        },


        watch: {
            datasets() {
                this.draw();
            }
        },

        mounted() {
            bus.$on('update-charts', () => {
                this.draw();
            });

            this.draw();
        },

        computed: {
            classes() {
                return {
                    'GraphLegend__item': true,
                    'GraphLegend__item--with-comparison': this.hasComparison
                }
            },

            total() {
                return _.sum(this.datasets[0].data);
            },

            comparisonTotal() {
                return this.datasets[1] ? _.sum(this.datasets[1].data) : 0;
            },

            hasComparison() {
                return ! _.isEmpty(this.comparisonValues);
            },
        },

        methods: {
            /**
             * Set the values for colours and values
             */
            draw() {
                this.displayLabels = this.limit ? _.take(_.cloneDeep(this.labels), 5) : _.cloneDeep(this.labels);

                this.colours = this.limit ?
                    _.take(_.cloneDeep(this.datasets)[0].backgroundColor, this.limit) : _.cloneDeep(this.datasets)[0].backgroundColor;

                this.values = this.limit ?
                    _.take(_.cloneDeep(this.datasets)[0].data, this.limit) : _.cloneDeep(this.datasets)[0].data;

                if (this.datasets[1]) {
                    this.comparisonValues = this.limit ?
                        _.take(_.cloneDeep(this.datasets)[1].data, 5) : _.cloneDeep(this.datasets)[1].data
                } else {
                    this.comparisonValues = [];
                }
            },

            /**
             * Get the background colour at the given index
             */
            backgroundColour(index) {
                return 'background:' + this.colours[index];
            },

            /**
             * Sometimes the labels may come across as an array so
             * check it and return the correct value
             * @param label
             * @return {*}
             */
            getLabel(label) {
                return _.isArray(label) ? label[0] : label;
            },

            /**
             * Get the value for the given index
             * @param index
             * @return {*}
             */
            value(index, type) {
                if (this.displayValue == 'value') {
                    return this[type][index];
                }

                let total = type == 'values' ? this.total : this.comparisonTotal;

                return total > 0 ? (this[type][index] / total * 100).toFixed(1) + '%' : 0;
            }
        }
    }
</script>